module.exports = __webpack_public_path__ + "static/media/enable_location.2d69cc48.gif";